import { render, staticRenderFns } from "./AddQuestionDialog.vue?vue&type=template&id=5cf52fa2&scoped=true"
import script from "./AddQuestionDialog.vue?vue&type=script&lang=js"
export * from "./AddQuestionDialog.vue?vue&type=script&lang=js"
import style0 from "./AddQuestionDialog.vue?vue&type=style&index=0&id=5cf52fa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf52fa2",
  null
  
)

export default component.exports